<script lang="ts">
  export let kind: string;
  const messages: Record<string, [string, string]> = {
    forbidden: ["Kein Zugriff auf diese Seite", "Dein Konto hat dafür keine Berechtigung."],
    "not-found": ["Seite nicht gefunden", "Diese Seite ist nicht verfügbar."],
    unavailable: ["Verbindung nicht möglich", "Bitte versuche es gleich noch einmal."],
    blocked: ["Zugriff nicht möglich", "Bitte wende dich an die Administration."],
    "no-home": ["Keine Startseite verfügbar", "Für dein Konto ist derzeit keine passende Seite freigegeben."],
  };
  $: message = messages[kind] ?? messages.unavailable;
</script>

<main class="navigation-status">
  <h1>{message[0]}</h1>
  <p>{message[1]}</p>
  <div>
    {#if kind === "unavailable"}
      <button onclick={() => location.reload()}>Erneut versuchen</button>
    {:else if kind === "no-home" || kind === "blocked"}
      <a href="/user-authentication/login">Zur Anmeldung</a>
    {:else}
      <a href="/">Zur Startseite</a>
    {/if}
  </div>
</main>

<style>
  .navigation-status { max-width: 32rem; margin: 12vh auto; padding: 1.5rem; color: #172033; }
  h1 { font-size: 1.5rem; font-weight: 650; margin-bottom: .75rem; }
  p { color: #526071; margin-bottom: 1.5rem; }
  div { display: flex; flex-wrap: wrap; gap: .75rem; }
  a, button { border: 1px solid #cbd5e1; border-radius: .75rem; padding: .75rem 1rem; background: white; text-decoration: none; font: inherit; cursor: pointer; }
</style>
